'use client';
import { db } from '@/firebase/client';
import { Timestamp, collection, onSnapshot, query } from 'firebase/firestore';

export type NotificationType = {
  id: string; // 個人お知らせのuuid
  title: string;
  content: string;
  created_at: Timestamp;
};

// 通知数と内容を取る
export async function watchNotification(
  uid: string,
  onChange: (notifications: NotificationType[]) => void,
) {
  const q = query(collection(db, 'users', uid, 'notification'));
  return onSnapshot(q, (snapshot) => {
    const notifications = snapshot.docs.map((doc) => {
      return doc.data() as NotificationType;
    });
    onChange(notifications);
  });
}
